import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { events, formatEventDisplayDate, getEventSortDate } from '../events/Events';

function Home() {
  const navigationCards = [
    {
      title: "About Us",
      description: "Learn about our mission and history since 1923.",
      path: "/about",
      backgroundImage: "/images/home/about.png"
    },
    {
      title: "Our Media",
      description: "Discover our archive of markers, digital publications, and video content.",
      path: "/media",
      backgroundImage: "/images/home/media.png"
    },
    {
      title: "Events & Programs",
      description: "Join us for historical lectures and educational programs.",
      path: "/events",
      backgroundImage: "/images/home/upcoming-events.png"
    },
    {
      title: "Membership",
      description: "Support our mission and become a member.",
      path: "/support",
      backgroundImage: "/images/home/membership.png"
    }
  ];

  // Get the next upcoming event
  const today = new Date();
  const upcomingEvent = events
    .filter(event => getEventSortDate(event) >= today)
    .sort((a, b) => getEventSortDate(a) - getEventSortDate(b))[0];

  return (
    <div className="home">
      <section className="page-hero">
        <div className="hero-header">
          <img 
            src="/images/HCHS_Logo.png" 
            alt="Harris County Historical Society Logo" 
            className="hero-logo"
          />
          <div>
            <h1>Welcome to Harris County Historical Society</h1>
            <p>Connecting our community with over 100 years of local history</p>
            <div className="hero-buttons">
              <Link to="/support" className="button-outline">Become a Member</Link>
              <Link to="/support?tab=donate" className="button-outline">Make a Donation</Link>
            </div>
          </div>
        </div>
      </section>

      <div className="page-container">
        <section className="about-preview section">
          <div className="about-preview-content">
            <div className="about-preview-text">
              <h2>What is the Harris County Historical Society?</h2>
              <p>
                The purpose of the Harris County Historical Society is to encourage, advocate and administer the discovery, collection, preservation and publication of historical information, records, oral histories, visuals and other materials relating to the history of Harris County, and to educate the public about the important history of Harris County, Texas.
              </p>
              <p>
                The Harris County Historical Society was founded on October 2, 1923, in honor of the 88th anniversary of the Battle of Gonzales. Over 100 years later, we are focused on preserving and sharing our county's rich heritage through monthly dinner meetings, educational programs, historical research support, and community engagement initiatives.
              </p>
              <div className="button-group">
                <Link to="/about" className="button">Learn More</Link>
              </div>
            </div>
            <div className="about-preview-image">
              <img src="/images/home/houston-old.png" alt="Harris County Historical Society" />
            </div>
          </div>
        </section>

        <hr className="section-divider" />

        {upcomingEvent && (
          <section className="upcoming-events section">
            <h2>Upcoming Events</h2>
            <div className="meeting-details">
              <div className="meeting-content">
                <h3>{upcomingEvent.title}</h3>
                <div className="event-info">
                  <div className="event-meta">
                    <p className="date">{formatEventDisplayDate(upcomingEvent)}</p>
                    <p className="time">
                      Social Time: {upcomingEvent.times.social} • 
                      Dinner: {upcomingEvent.times.dinner} • 
                      Program: {upcomingEvent.times.program}
                    </p>
                    <p className="presenter">Presenter: {upcomingEvent.presenter}</p>
                  </div>
                  <div className="button-group">
                    <Link 
                      to={`/events?expand=${upcomingEvent.id}`}
                      className="button"
                    >
                      Read More →
                    </Link>
                    <Link to={upcomingEvent.rsvpLink} className="button">RSVP Now</Link>
                  </div>
                </div>
              </div>
              <div className="meeting-image">
                <img src={upcomingEvent.image} alt={upcomingEvent.title} />
              </div>
            </div>
            <div className="view-all-events">
              <Link to="/events" className="navigation-row">
                <div className="row-content">
                  <h3>View All Events</h3>
                  <p>See our complete calendar of upcoming programs and lectures</p>
                </div>
                <span className="button">View Calendar</span>
                <div className="hover-background" style={{ backgroundImage: `url(/images/home/upcoming-events.png)` }} />
              </Link>
            </div>
          </section>
        )}

        {upcomingEvent && <hr className="section-divider" />}

        <section className="navigation-section">
          <h2>Explore More</h2>
          <div className="navigation-list">
            {navigationCards.map((card, index) => (
              <Link to={card.path} key={index} className="navigation-row">
                <div className="row-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
                <span className="button">Learn More</span>
                <div className="hover-background" style={{ backgroundImage: `url(${card.backgroundImage})` }} />
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home; 